import { render, staticRenderFns } from "./SelectContentType.vue?vue&type=template&id=18720355&"
import script from "./SelectContentType.vue?vue&type=script&lang=js&"
export * from "./SelectContentType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports